var _path, _polygon, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShieldExclamation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    "aria-labelledby": titleId,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 48",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "shieldExclamationTitle"
  }, "Shield with Exclamation") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "shieldExclamationTitle"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,0L0,3.7v17c0,20,19.5,27.2,19.7,27.3L20,48l0.3-0.1c0.2-0.1,19.7-7,19.7-27.3v-17L20,0z M38,20.6  c0,17.6-15.4,24.3-18,25.2c-2.5-1-18-8-18-25.2V5.3L20,2l18,3.3V20.6z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "19.2 24 21.2 24 21.8 10 18.8 10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m18.2 30c0 1.1 0.9 2 2 2s2-0.9 2-2-0.9-2-2-2-2 0.9-2 2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldExclamation);
export default __webpack_public_path__ + "static/media/shield-exclamation.4c70ddca5ea1586f745ef21c10984b19.svg";
export { ForwardRef as ReactComponent };